import { Injectable, NgZone } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class ReportService {
    // public campaignThemeSaved: Subject<CampaignThemeId>;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private zone: NgZone,
        private _sanitizer: DomSanitizer
    ) {
        // this.campaignThemeSaved = new Subject<CampaignThemeId>();
    }

    getWireReport(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('report/wire', params);
    }

    confirmTusReport(ids: Array<number>): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.put<ApiPagedResponse<any>>('report/confirm-tus-report', {
            poIds: ids
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/report.service.ts